.dynamic-entry-vin-modal-heading {
  font-family: var(--font-family-ico-heading);
}

.dynamic-entry-vin-modal-error {
  font-family: var(--font-family-ico-body);
  color: var(--color-error);
}

.dynamic-entry-vin-modal-error svg-icon {
  fill: var(--color-error);
}

ico-modal div[role='dialog'] {
  @apply p-4 w-auto;
}

.vin-modal-button-group {
  flex-direction: column-reverse;
}

@media (min-width: 768px) {
  .vin-modal-button-group {
    flex-direction: row;
  }
}
